// removed by extract-text-webpack-plugin
module.exports = {"Title":"OrderSummary__Title__2PzGl","Subtitle":"OrderSummary__Subtitle__3fyxK","Lines":"OrderSummary__Lines__6IYTs","Name":"OrderSummary__Name__2veGE","Count":"OrderSummary__Count__2LkE7","Total":"OrderSummary__Total__3Widl","Actions":"OrderSummary__Actions__3mRnj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/OrderSummary/OrderSummary.css
// module id = 53
// module chunks = 0